import { Space, TextLoader } from '@procurify/ui'

export const BankingDetailsLoader = () => {
  return (
    <Space>
      <>
        <TextLoader width={100} height={12} />
        <TextLoader width={120} height={14} />
      </>
      <>
        <TextLoader width={100} height={12} />
        <TextLoader width={120} height={14} />
      </>
      <>
        <TextLoader width={100} height={12} />
        <TextLoader width={120} height={14} />
      </>
    </Space>
  )
}
